import BaseAPI from '@/apis/base'
import { apis, getApiUrl } from '../api-config'

class NotifyAPI extends BaseAPI {}

export default new NotifyAPI('v1/notifies', 'Notify', getApiUrl(apis.CommonAPI))
